export const isIframe = () => window.self !== window.top;
